import React, { Component } from 'react';
import './ObjectBlock.css'

interface MyProps {
  action: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void,
  children: any
}

class ObjectBlock extends Component<MyProps, any> {
  render() {
    return (
      <div onClick={this.props.action} className="ObjectBlock">
        {this.props.children}
      </div>
    );
  }
}



export default ObjectBlock;
